import React from "react";
import { useNavigate } from "react-router-dom";
import CapacityCalendar from "@/components/CapacityCalendar";
import { Button } from "@/components/ui/button";

const Container = ({ children }) => <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">{children}</div>;

export default function PublicAvailability() {
  const navigate = useNavigate();
  return (
    <Container>
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Disponibilités</span>
      <h1 className="mt-3 font-heading font-bold tracking-tight text-slate-900 text-4xl sm:text-5xl">Notre capacité en un coup d'œil</h1>
      <p className="mt-5 text-lg text-slate-600 max-w-2xl">Consultez la disponibilité indicative de notre équipe. Pour réserver un créneau précis, créez votre espace client.</p>
      <div className="mt-10"><CapacityCalendar /></div>
      <p className="mt-4 text-sm text-slate-500">Les disponibilités affichées sont indicatives et seront confirmées par notre équipe.</p>
      <div className="mt-6 flex gap-3"><Button className="bg-primary" onClick={() => navigate("/demande")}>Faire une demande</Button><Button variant="outline" onClick={() => navigate("/inscription")}>Créer mon espace</Button></div>
    </Container>
  );
}
